import React, { useEffect, useState } from "react";
import { Box, Typography, Drawer, IconButton, Divider, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Table from "react-bootstrap/Table";
import { MenuItem, Grid, Select } from "@mui/material";
import GetInitiativeHistory from "app/hooks/Editpage/GetPrioritizationCheckListHistory";
import { Dropdown } from "@fluentui/react";
// Added by Gauri to fix dropdown position issue on 20 Nov 2025
import { DirectionalHint } from "@fluentui/react";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";
//        Modified By Durgesh Dalvi: changed the implementation of this component to ensure the data first get
//        fetched and then the appendentation of table begins
const InitiativeHistoryDrawer = ({ isOpen, onClose, id1, UniqueID }) => {
  const [initiativeHistory, setInitiativeHistory] = useState({
    // Modified by Gauri to fix checklist history issue on 31 Oct 2025
    // data: { listPrioritizationChecklist: [] }
    data: { listChecklistMakerInboxHistory: [] }
  });
  const [dropdownOptions, setDropdownOptions] = useState({
    modifiedFieldOptions: [],
    modifiedByOptions: []
  });

  const [filteredHistory, setFilteredHistory] = useState([]);
  const [selectedField, setSelectedField] = useState("");
  const [selectedBy, setSelectedBy] = useState("");
  // Changed items count to 5 by Gauri on 17 Apr 2025
  const [itemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  // Added totalCount by Gauri to fix pagination issue on 17 Apr 2025
  const [totalCount, setTotalCount] = useState(0);

  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;

  // Added function by Gauri to Bind History data on 20 Mar 2025
  const fetchHistoryData = async () => {
    const modifiedField = selectedField || ""; // Use selectedField or default
    const modifiedBy = selectedBy || ""; // Use selectedBy or default

    try {
      const history = await GetInitiativeHistory(
        id1,
        currentPage,
        UniqueID,
        // selectedBy,
        // selectedField
        modifiedBy,
        modifiedField
      );
      console.log("API Response:", history);

      // if (history?.data?.listPrioritizationChecklist) {
      if (history?.data?.listChecklistMakerInboxHistory) {    // Modified by Gauri to fix checklist history issue on 31 Oct 2025
        setInitiativeHistory(history);
        // setFilteredHistory(history.data.listPrioritizationChecklist);
        setFilteredHistory(history.data.listChecklistMakerInboxHistory);   // Modified by Gauri to fix checklist history issue on 31 Oct 2025
        // Added totalCount by Gauri to fix pagination issue on 17 Apr 2025
        // const totalCountFromAPI = history.data.listPrioritizationChecklist[0]?.totalCount || 0;
        // const totalCountFromAPI = history.data.listChecklistMakerInboxHistory[0]?.totalCount || 0;   // Modified by Gauri to fix checklist history issue on 31 Oct 2025
        const totalCountFromAPI = history.paginationEntities?.[0]?.totalRecords || 0;   // Modified by Gauri to fix checklist history issue on 31 Oct 2025
        setTotalCount(totalCountFromAPI);
      } else {
        // setInitiativeHistory({ data: { listPrioritizationChecklist: [] } }); // Prevent errors
        setInitiativeHistory({ data: { listChecklistMakerInboxHistory: [] } });   // Modified by Gauri to fix checklist history issue on 31 Oct 2025
        // Added totalCount by Gauri to fix pagination issue on 17 Apr 2025
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Added function by Gauri to Filter History data on 21 Mar 2025
  // Modified by Gauri to fix filter issue on 31 Oct 2025 - added selectedField and selectedBy to dependencies
  useEffect(() => {
    fetchHistoryData();
  }, [id1, currentPage, UniqueID, selectedField, selectedBy]); // Added selectedField and selectedBy to trigger API call on filter change

  // Commented by Gauri as client-side filtering useEffect since filtering is now done server-side via API
  // The API returns filtered results, so we just set the filteredHistory directly from API response  

  // useEffect(() => {
  //   // Modified by Gauri to fix checklist history issue on 31 Oct 2025
  //   // if (initiativeHistory?.data?.listPrioritizationChecklist) {
  //     // let filteredData = initiativeHistory.data.listPrioritizationChecklist;
  //   if (initiativeHistory?.data?.listChecklistMakerInboxHistory) {
  //     let filteredData = initiativeHistory.data.listChecklistMakerInboxHistory;
  
  //     if (selectedField) {
  //       filteredData = filteredData.filter((item) => item.fieldName === selectedField);
  //     }
  
  //     if (selectedBy) {
  //       filteredData = filteredData.filter((item) => item.modifiedBy === selectedBy);
  //     }
  
  //     setFilteredHistory(filteredData);
  //   }
  // }, [selectedField, selectedBy, initiativeHistory]); // Runs only when filters or data change  

  const fetchDropdownData = async (fieldName, setOptionsCallback) => {
    try {
      const response = await AxiosInstance1.get(
        `/api/InitiativeDetail/GetDropDownDetails?&userID=${employeeId}&FieldName=${fieldName}&IdeaId=${id1}&UniqueID=${UniqueID}`,
        // {
        //   method: "GET",
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
        //   }
        // }
      );

      // if (!response.ok) {
      //   throw new Error(`Failed to fetch options for ${fieldName}`);
      // }

      const data = response?.data;
      const options = data.data.listInitiativeDetailDropDownEntity.map((item) => ({
        key: item.id,
        text: item.name
      }));
      setOptionsCallback(options);
    } catch (error) {
      console.error(`Error fetching options for ${fieldName}:`, error);
    }
  };

  useEffect(() => {
    fetchDropdownData("modifiedField_prioritizationhistory", (options) =>
      setDropdownOptions((prev) => ({
        ...prev,
        modifiedFieldOptions: options
      }))
    );
    fetchDropdownData("modifiedby_prioritizationhistory", (options) =>
      setDropdownOptions((prev) => ({
        ...prev,
        modifiedByOptions: options
      }))
    );
  }, []);

  // Modified function by Gauri to Bind Dropdowns on 20 Mar 2025
  // Modified by Gauri to fix filter issue on 31 Oct 2025 - use text (name) instead of key (id) for API
  const handleFieldChange = (event, option) => {
    // If placeholder option is selected (empty key), clear the filter
    // Use option.text (field name) instead of option.key (id) since API expects ModifiedField as string
    if (option?.key === "" || !option) {
      setSelectedField("");
    } else {
      setSelectedField(option?.text || "");
    }
    setCurrentPage(1); // Reset pagination to trigger API fetch with new filter
  };
  
  // Modified by Gauri to fix filter issue on 31 Oct 2025 - use text (name) instead of key (id) for API
  const handleByChange = (event, option) => {
    // If placeholder option is selected (empty key), clear the filter
    // Use option.text (name) instead of option.key (id) since API expects ModifiedBy as string
    if (option?.key === "" || !option) {
      setSelectedBy("");
    } else {
      setSelectedBy(option?.text || "");
    }
    setCurrentPage(1); // Reset pagination to trigger API fetch with new filter
  };  
  // End of Modified function by Gauri to Bind Dropdowns on 20 Mar 2025
  
  // const handleActionTypeChange = (event, option) => {
  //   setSelectedActionType(option.key);
  //   setCurrentPage(1); // Reset pagination on filter change
  // };
  
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  // Added by Gauri on 20 Nov 2025 - Common calloutProps for all dropdowns
  const commonCalloutProps = {
    // Use bottomAutoEdge which tries to open downward first, then automatically adjusts upward if needed
    directionalHint: DirectionalHint.bottomAutoEdge,
    // Set max height to prevent dropdown from being too large
    calloutMaxHeight: 250,
    // Ensure dropdown stays within viewport bounds
    bounds: typeof window !== 'undefined' ? {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    } : undefined
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{ width: "65vw", padding: 2, position: "relative" }}>
        {/* <IconButton onClick={onClose} sx={{ position: "absolute", top: 17, right: 12 }}>
          <Tooltip title="Close">
            <CloseIcon />
          </Tooltip>
        </IconButton>
        <Typography variant="h6" gutterBottom style={{ background: "#E7EDF0", width: "100%" }}>
          Prioritization CheckList History
        </Typography> */}

        {/* Modified section by Gauri on 09 Apr 2025 */}
        <div
          className="mb-1"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#f5f5f5", // Light grey background
            padding: "10px" // Optional: Adds padding to make it look more balanced
          }}
        >
          <Typography variant="h6">Prioritization Checklist History</Typography>
          <Tooltip title="Close">
            <CloseIcon className="IcnStyle" onClick={onClose} />
          </Tooltip>
        </div>

        <Box sx={{ padding: "10px 20px" }}>
          {/* <Divider /> */}
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 2 }}>
            <Grid item xs={6}>
              <Typography variant="subtitle1" sx={{ fontSize: "0.775rem" }}>Modified Field</Typography>
              {/* Added by Gauri to change dropdown in FluentUI on 21 Mar 2025 */}
              {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
              <Dropdown
                placeholder="Select Modified Field"
                options={[
                  { key: "", text: "Select Modified Field" },
                  ...dropdownOptions.modifiedFieldOptions
                ]}
                // Modified by Gauri to fix filter issue on 31 Oct 2025 - find by text value instead of key
                selectedKey={selectedField ? dropdownOptions.modifiedFieldOptions.find(opt => opt.text === selectedField)?.key : null}
                onChange={handleFieldChange}
                styles={{ dropdown: { width: 200 } }}
                calloutProps={commonCalloutProps}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle1" sx={{ fontSize: "0.775rem" }}>Modified By</Typography>
              {/* Commented and Added by Gauri to change dropdown in FluentUI on 21 Mar 2025 */}
              {/* <Select fullWidth value={selectedBy} onChange={handleByChange}
                size="small" sx={{ maxWidth: 200 }} displayEmpty >
                <MenuItem value="">Select Modified By</MenuItem>
                {dropdownOptions.modifiedByOptions.map((option) => (
                  <MenuItem key={option.key} value={option.key}> {option.text} </MenuItem>
                ))}
              </Select> */}
              {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
              <Dropdown
                placeholder="Select Modified By"
                options={[
                  { key: "", text: "Select Modified By" },
                  ...dropdownOptions.modifiedByOptions
                ]}
                // Modified by Gauri to fix filter issue on 31 Oct 2025 - find by text value instead of key
                selectedKey={selectedBy ? dropdownOptions.modifiedByOptions.find(opt => opt.text === selectedBy)?.key : null}
                onChange={handleByChange}
                styles={{ dropdown: { width: 200 } }}
                calloutProps={commonCalloutProps}
              />
            </Grid>
          </Grid>

          {/* Table to display initiative history */}
          <Table striped bordered responsive>
            <thead>
              <tr>
                <th>Modified Field</th>
                <th>Modified Date</th>
                {/* Added by Gauri to fix checklist history issue on 31 Oct 2025 */}
                <th>Old Value</th>
                <th>New Value</th>
                <th>Modified By</th>
              </tr>
            </thead>
            <tbody>
              
              {/* Commented and Modified by Gauri to filter history data on 21 Mar 2025 */}
              {/* {initiativeHistory?.data?.listPrioritizationChecklist?.length > 0 ? (
                initiativeHistory.data.listPrioritizationChecklist.map((item, index) => ( */}
                {filteredHistory.length > 0 ? (
                  filteredHistory.map((item, index) => (
                  <tr key={index}>
                    {/* <td>{item.fieldName}</td> */}
                    <td>{item.modifiedField}</td>    {/* Modified by Gauri to fix checklist history issue on 31 Oct 2025 */}
                    <td>{new Date(item.modifiedDate).toLocaleDateString("en-GB")}</td>
                    {/* <td>{item.value}</td>     */}
                    <td>{item.oldValue}</td>    {/* Added by Gauri to fix checklist history issue on 31 Oct 2025 */}  
                    <td>{item.newValue}</td>    {/* Added by Gauri to fix checklist history issue on 31 Oct 2025 */}  
                    <td>{item.modifiedBy}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>    {/* Modified by Gauri to fix checklist history issue on 31 Oct 2025 */} 
                    There are no items to show in this view.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination controls */}
          <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <IconButton onClick={handlePreviousPage} disabled={currentPage === 1}>
              <ArrowBackIcon />
            </IconButton>
            <Typography sx={{ margin: "0 10px", alignSelf: "center" }}>Page {currentPage}</Typography>
            <IconButton
              onClick={handleNextPage}
              // disabled={initiativeHistory.data.listPrioritizationChecklist.length === 0}
              // Added totalCount by Gauri to fix pagination issue on 17 Apr 2025
              disabled={currentPage * itemsPerPage >= totalCount}
            >
              <ArrowForwardIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default InitiativeHistoryDrawer;
